import Bjax from '@bilibili/bjax'

export const bjax = new Bjax()

const getRequestPrefix = () => {
  if (process.env.PUSH_ENV === 'uat') {
    return 'uat-'
  }

  if (/\/preview\//.test(window.location.href)) {
    return 'pre-'
  }
  return ''
}

export const getApplyInfo = (data) => {
    return new Promise((resolve, reject) => {
      bjax
        .get(
          `//${getRequestPrefix()}baselabs.bilibili.com/x/gallery/face_apply_info`,
          data,
          {
            withCredentials: true,
          }
        )
        .then((res) => {
          if (res?.code) {
            reject(res)
            return
          }
          resolve(res?.data)
        })
        .catch(reject)
    })
}

export const getApplyCurrent = () => {
  return new Promise((resolve, reject) => {
    bjax
      .get(`//${getRequestPrefix()}baselabs.bilibili.com/x/gallery/face_apply_current`)
      .then(res => {
        if (res?.code) {
          reject(res)
          return
        }
        resolve(res?.data)
      })
      .catch(reject)
  })
}

export const apply = (data) => {
    return new Promise((resolve, reject) => {
        bjax
          .post(
            `//${getRequestPrefix()}baselabs.bilibili.com/x/gallery/face_apply`,
            data,
            {
              withCredentials: true,
            }
          )
          .then((res) => {
            if (res?.code) {
              reject(res)
              return
            }
            resolve(res?.data)
          })
          .catch(reject)
      })
}
